/**
 * Returns the CSS class for a session badge color, cycling through the palette.
 * Used to visually link a session card on /cart with its row in the order summary.
 */
export const getSessionBadgeClass = (index: number): string => {
    return `session-badge-${(index % 5) + 1}`;
};